import { useMemo, useState } from "react";
import "./PauseIndicatorBanner.scss";
import AuthService from "src/services/AuthService";
import RiskApprovalModal from "./RiskApprovalModal";
import { Applicant } from "src/types/Applicant";

interface ApproveWithRiskScoreButtonProps {
  applicationId: number;
  highRiskApplicants?: Applicant[];
  onApprovalSuccess?: () => void;
}

const ApproveWithRiskScoreButton = ({
  applicationId,
  highRiskApplicants = [],
  onApprovalSuccess,
}: ApproveWithRiskScoreButtonProps) => {
  const [showApprovalModal, setShowApprovalModal] = useState(false);

  // Check if current user is authorized using AuthService
  const isAuthorizedUser = useMemo(() => {
    return AuthService.isAuthorizedForRiskScoreApproval();
  }, []);

  // Only show button if user is authorized and there are high-risk applicants
  if (!isAuthorizedUser || highRiskApplicants.length === 0) {
    return null;
  }

  const handleApprovalConfirm = (wasSuccessful: boolean) => {
    setShowApprovalModal(false);
    if (wasSuccessful) {
      onApprovalSuccess?.();
    }
  };

  return (
    <>
      <div className="pause-actions">
        <span
          className="pause-action-text"
          role="button"
          tabIndex={0}
          onClick={() => setShowApprovalModal(true)}
        >
          Unpause Application
        </span>
      </div>
      <RiskApprovalModal
        showModal={showApprovalModal}
        applicationId={applicationId}
        highRiskApplicants={highRiskApplicants}
        onConfirmApprove={handleApprovalConfirm}
        onCancel={() => setShowApprovalModal(false)}
      />
    </>
  );
};

export default ApproveWithRiskScoreButton;
